import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Output,
} from '@angular/core';

@Directive({
  selector: '[appClickOutside]',
})
export class ClickOutsideDirective {
  @Output() appClickOutside: EventEmitter<void> = new EventEmitter();

  constructor(private elementRef: ElementRef) {}

  @HostListener('document:mousedown', ['$event'])
  @HostListener('document:touchstart', ['$event'])
  public onClick(ev: any) {
    const clickedInside = this.elementRef.nativeElement.contains(ev.target);
    if (!clickedInside) {
      ev.preventDefault();
      ev.stopPropagation();
      this.appClickOutside.emit();
    }
  }
}
